
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M13.21 6.88l-.633-.224a.687.687 0 01-.39-.943l.288-.606a1.188 1.188 0 00-1.582-1.583l-.607.289a.687.687 0 01-.942-.391l-.225-.633a1.188 1.188 0 00-2.238 0l-.225.633a.688.688 0 01-.943.39l-.606-.288a1.188 1.188 0 00-1.583 1.583l.288.606a.688.688 0 01-.39.943l-.633.225a1.187 1.187 0 000 2.238l.633.225a.687.687 0 01.39.942l-.288.607a1.188 1.188 0 001.583 1.582l.606-.288a.687.687 0 01.943.39l.225.633a1.188 1.188 0 002.238 0l.225-.633a.687.687 0 01.942-.39l.607.288a1.188 1.188 0 001.582-1.582l-.288-.607a.687.687 0 01.39-.942l.633-.226a1.187 1.187 0 000-2.237zM8 10.393A2.465 2.465 0 015.78 8.92a2.406 2.406 0 011.3-3.141 2.434 2.434 0 013.14 1.3 2.407 2.407 0 01-1.3 3.14c-.292.12-.605.179-.92.173z"}})])
          )
        }
      }
    